import { useId } from "react"

import * as Icones from "./Icones"
import { Switch } from "./Switch"
import { cn } from "../lib/cn"

export function SwitchDeModo({ escuro, aoMudar }: { escuro: boolean; aoMudar: (escuro: boolean) => void }) {
  const id = useId()
  const lado = "flex cursor-pointer items-center"
  return (
    <div data-slot="switch-de-modo" data-state={escuro ? "checked" : "unchecked"} className="inline-flex items-center gap-2">
      <span
        data-lado="claro"
        aria-hidden="true"
        className={cn(lado, escuro ? "text-muted-foreground" : "text-foreground")}
        onClick={() => aoMudar(false)}
      >
        <Icones.Sol tamanho={16} />
      </span>
      <Switch id={id} checked={escuro} onCheckedChange={aoMudar} aria-label="Modo escuro" />
      <span
        data-lado="escuro"
        aria-hidden="true"
        className={cn(lado, escuro ? "text-foreground" : "text-muted-foreground")}
        onClick={() => aoMudar(true)}
      >
        <Icones.Lua tamanho={16} />
      </span>
    </div>
  )
}
